import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList } from '../api/dataverseClient';
import { getAccount } from '../auth/authService';
import { ProjectMemberRole } from './projectMemberService';

// This app has no tenant-level role model — roles are per-project
// (ProjectMemberRole) and the Dataverse "Portfolio Manager" security role
// is server-side only with no client-readable claim. We approximate
// "Portfolio Manager and above" for portfolio-level authoring gates:
// anyone who is a ProjectManager on at least one project qualifies.
//
// DENY BY DEFAULT: a user with zero projectmember rows (no role on any
// project) is NOT allowed through — an unassigned user must not reach these
// gated portfolio actions/views. Only the query-failure case stays lenient
// (a transient error shouldn't lock out a legitimately-permissioned user).
export async function isPortfolioManagerOrAbove(pca: IPublicClientApplication): Promise<boolean> {
  try {
    const acct = await getAccount(pca);
    const oid = acct?.localAccountId ?? acct?.homeAccountId?.split('.')[0] ?? '';
    if (!oid) return false;
    const rows = await dvList<{ dagrun_pm_projectmemberid: string; dagrun_pm_role: number | null }>(
      pca, 'dagrun_pm_projectmembers', {
        select: ['dagrun_pm_projectmemberid', 'dagrun_pm_role'],
        filter: `dagrun_pm_userid eq '${oid}'`, top: 50,
      });
    if (rows.length === 0) return false; // no role anywhere → deny
    return rows.some(m => m.dagrun_pm_role === ProjectMemberRole.ProjectManager);
  } catch {
    return true; // query failed → don't lock out a permissioned user
  }
}
